<template>
 <body>

  <!-- header for tv START -->
  <div class="header header-tv">

    <!-- col-1 start -->
    <div class="col-1">

    <!-- start logo tv -->
      <div class="leftcol-banner logoTv">
        <img src="@/assets/images/banner-1.svg" alt="" />
      </div>
    <!-- stop logo tv -->

    </div>
    <!-- col-1 stop -->

    <!-- col-2 start -->
    <div class="col-2">

      <!-- jackpot start -->
      <div class="jackpotBox">
        <img src="@/assets/images/jackpot.svg" alt="" />
        <div class="jackpotNumber" v-if="$store.state.jackpot">{{$store.state.jackpot.Amount.toFixed(2)}}</div>
      </div>
      <!-- jackpot stop -->

    </div>
    <!-- col-2 stop -->

    <!-- col-1 start -->
    <div class="col-1">

      <div class="start">START</div>

      <!-- start -->
      <div class="counterTime" v-on="countDownTimer()" v-if="game">
        <div>0</div>
        <div>{{game.time.min[0]}}</div>
        <i>:</i>
        <div>{{game.time.sec.length == 2 ? game.time.sec[0] : 0}}</div>
        <div>{{game.time.sec.length == 2 ? game.time.sec[1] : game.time.sec[0]}}</div>
      </div>
      <!-- stop -->

    </div>
    <!-- col-1 stop -->

  </div>
  <!-- header for tv STOP -->

  <!-- main START -->
  <div class="main">

    <!-- left col for tv START -->
    <div class="leftCol leftCol-tv">

      <!-- leftcol-banner start -->
      <div class="leftcol-banner">

        <div class="leaguetv" v-if="$store.state.game">
          <div>{{$t('league')}}</div>
          <div>{{$store.state.game.League}}</div>
        </div>

        <div class="weektv" v-if="$store.state.game">
          <div>{{$t('week')}}</div>
          <div>{{$store.state.game.Week}}</div>
        </div>

      </div>
      <!-- leftcol-banner stop -->

      <!-- leftcol-container start -->
      <div class="leftcol-container" v-if="$store.state.game">

        <!-- row start -->
        <div class="row active" v-for="item, key in $store.state.game.Match" @click="$router.push({name: 'MatchDetails', params: item})">
          <div class="td">{{key+1}}</div>
          <div class="td">
            <div class="icon"><img :src="getimg(item.HomeTeam)" alt=""></div>
          </div>
          <div class="td">{{getteams(item.HomeTeam)}}</div>
          <div class="td">vs</div>
          <div class="td">{{getteams(item.AwayTeam)}}</div>
          <div class="td">
            <div class="icon"><img :src="getimg(item.AwayTeam)" alt=""></div>
          </div>
        </div>
        <!-- row stop -->

      </div>
      <!-- leftcol-container stop-->

    </div>
    <!-- left col for tv STOP -->

    <!-- center col for tv START -->
    <div class="centerCol center-10col centerCol-tv"><!-- class center-10col когда в центральном блоке 12 колонок -->

      <!-- row-th6-top start -->
      <div class="row-th6-top">
        <div class="th lightgreen">{{$t('winner')}}</div>
        <div class="th">{{$t('dblc')}}</div>
        <div class="th lightgreen">{{$t('gng')}}</div>
        <div class="th">{{$t('ov')}}/{{$t('un')}}2.5</div>
      </div>
      <!-- row-th6-top stop -->

      <!-- row-th10-continuous start -->
      <div class="row-th10-continuous">
        <div class="th">1</div>
        <div class="th">X</div>
        <div class="th">2</div>
        <div class="th">1X</div>
        <div class="th">12</div>
        <div class="th">X2</div>
        <div class="th">{{$t('gg')}}</div>
        <div class="th">{{$t('ng')}}</div>
        <div class="th">{{$t('ov')}}2.5</div>
        <div class="th">{{$t('un')}}2.5</div>
      </div>
      <!-- row-th10-continuous stop -->

      <!-- td-center-block start -->
      <div class="td-center-block" v-if="$store.state.game">

        <!-- row-td10 start -->
        <div class="row-block row-td10" v-for="item in $store.state.game.Match">
          <div class="row-conainer">
            <div class="td">{{item.Odds['1']}}</div><!-- +/- class bordeaux -->
            <div class="td">{{item.Odds['X']}}</div><!-- +/- class bordeaux -->
            <div class="td">{{item.Odds['2']}}</div><!-- +/- class bordeaux -->
            <div class="td">{{item.Odds['1X']}}</div><!-- +/- class bordeaux -->
            <div class="td">{{item.Odds['12']}}</div><!-- +/- class bordeaux -->
            <div class="td">{{item.Odds['X2']}}</div><!-- +/- class bordeaux -->
            <div class="td">{{item.Odds['GG']}}</div><!-- +/- class bordeaux -->
            <div class="td">{{item.Odds['NG']}}</div><!-- +/- class bordeaux -->
            <div class="td">{{item.Odds['Over(2.5)']}}</div><!-- +/- class bordeaux -->
            <div class="td">{{item.Odds['Under(2.5)']}}</div><!-- +/- class bordeaux -->
          </div>
        </div>
        <!-- row-td10 stop -->
          
      </div>
      <!-- td-center-block stop -->

    </div>
    <!-- center col for tv STOP -->

    <!-- right col for tv START -->
    <div class="rightCol rightCol-tv">

      <!-- start -->
      <div class="leftcol-container">

        <!-- row start repeat -->
        <div class="row" v-for="item, key in $store.state.teams">
          <div class="td">{{key+1}}</div>
          <div class="td">
            <div class="icon"><img :src="getimg(item.id)" alt=""></div>
          </div>
          <div class="td">{{item.Abriviation}}</div>
          <div class="td">{{item.Score}}</div>
          <div class="td" v-for="i in 4" v-if="$store.state.gameresults"><p class="rd"><span :style="getBackground(getRes(i, item.id))">{{getRes(i, item.id)}}</span></p></div>
          
        </div>
        <!-- row stop repeat -->

      </div>
      <!-- stop -->
        
    </div>
    <!-- right col for tv STOP -->

  </div>
  <!-- main STOP -->


  <tvfooter></tvfooter>

  
</body>
</template>

<script>
import tvfooter from '@/components/TVfooter.vue'
import countdown from '@/components/tvcountdown.js'
import Cookies from 'js-cookie'

export default {
  name: 'TV',
  timer: 0,
  data: function(){
    return {
      count: 0,
    }
  },
  created: function () {
    this.$i18n.locale = this.$route.params.lang;
      this.$store.dispatch('apirequest', { name: "jackpot/"+this.$route.params.Token});
      this.$store.dispatch('apirequest', { name: "jackpot/last/"+this.$route.params.Token});
      this.$store.dispatch('apirequest', { name: "game/results"});
      this.$store.dispatch('apirequest', {name: "teams/"}).then(()=>{
        this.$store.state.teams.sort((a, b) => a.Score - b.Score).reverse()
      });
      this.$store.dispatch('apirequest', {token: this.$route.params.Token, name: "game/"}).then((response) => {
        this.$store.state.Time = Math.floor((response.data.Time - Date.now()) / 1000 );
      });
  },
  mixins: [countdown],
  components: {
    tvfooter
  },
  destroyed() {
      clearInterval(this.$options.timer);
    },
  methods: {
    countDownTimer() {
      if(!this.$store.state.game) return
        if(this.$store.state.Time > 0) {
          //here i think I need better way
          if(this.$store.state.Time < 180 && this.count < 10){
            this.$store.state.Time += 60;
          }
          if(Math.floor((this.$store.state.game.Time - Date.now()) / 1000) < 180 && Number.isInteger(this.$store.state.Time) && this.count > 10){
            this.$router.push({name: 'TV3', params: {Token: this.$route.params.Token, lang: this.$route.params.lang}});
          }
          if(!this.$options.timer){
            this.$options.timer = setInterval(() => {
              if(this.$store.state.Time < 180 && this.count < 10){
                this.$store.state.Time += 60;
              }
              this.count += 1;
              this.$store.state.Time = Math.floor((this.$store.state.game.Time - Date.now()) / 1000);
            }, 1000)
          }
        }else{
          this.$store.dispatch('apirequest', {token: 0, name: "game/"}).then((response) => {
            this.$store.state.Time = Math.floor((this.$store.state.game.Time - Date.now()) / 1000);
          });
        }
    },
    getRes(num, id){
      if(!this.$store.state.game) return
      if(this.$store.state.game.Week == 1) return
      if(this.$store.state.game.Week == 2 && num > 1) return
      if(this.$store.state.game.Week == 3 && num > 2) return
      if(this.$store.state.game.Week == 4 && num > 3) return
      let res = this.$store.state.gameresults.filter(element => element.HomeTeam == id || element.AwayTeam == id);
      if(res[num-1].Result == null) return 'E'
      let home = parseInt(res[num-1].Result[0]);
      let away = parseInt(res[num-1].Result[2]);
      if(home == away){
        return 'D'
      }else if(home > away){
        if(res[num-1].HomeTeam == id){
          return 'W'
        }else{
          return 'L'
        }        
      }else if(home < away){
        if(res[num-1].HomeTeam == id){
          return 'L'
        }else{
          return 'W'
        }
      }      
    },
    getBackground(res){
      if(this.$store.state.game == null) return
      if(this.$store.state.game.Week == 1) return
      if(this.$store.state.game.Week == 2 && res == null) return
      if(this.$store.state.game.Week == 3 && res == null) return
      if(this.$store.state.game.Week == 4 && res == null) return
      if(res == "W") return {['background-color']: "#2BD05A"}
      if(res == "L") return {['background-color']: "#CE230D"}
      if(res == "D") return {['background-color']: "#A4830E"}
      if(res == "E") return {['background-color']: "#000000"}
    }   
  },
};
</script>

